<template>
  <v-container fluid class="container_bg">

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h1></h1>
        <h1>{{this.$i18n.locale == 'ko' ? '참가자삭제' : 'Visitor Delete'}}</h1>
      </v-col>
    </v-row>
    
    <v-divider/> 
    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <p></p>
        <p>{{this.$i18n.locale == 'ko' ? '참가자 정보를 삭제합니다.' : 'Delete participant information.'}}</p>
      </v-col>
    </v-row>

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h3>HTTP Request</h3>
      </v-col>
    </v-row>
    <v-row justify="center" dense>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">POST</v-col>
      <v-col cols="12" md="8" class="fielddesc">/fsApi/VisitorDelete</v-col>
    </v-row>
    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h3>Request Body</h3>
        <template v-if="$i18n.locale == 'ko'">
          요청 파라메터는 아래 표를 참고하세요. 요청 파라메터의 타입은 x-www-form-urlencoded 입니다.
        </template>
        <template v-else>
          Refer to the table below for request parameters. The request parameter type is x-www-form-urlencoded.
        </template>
      </v-col>
    </v-row>
    
    <v-row justify="center" dense>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">VISITOR_IDX</v-col>
      <v-col cols="12" md="8" class="pa-0" align-center="center">
        <table>
          <tr>
            <td width="100%" colspan="2">Number | <strong>Required</strong><br>
              <template v-if="$i18n.locale == 'ko'">
                삭제할 참가자의 IDX값
              </template>
              <template v-else>
                IDX value of participant to delete
              </template>
            </td>
          </tr>
        </table>
      </v-col>
    </v-row>
    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h3>Response Body</h3>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="12" md="11" class="fieldname"><h4>JSON representation</h4></v-col>
      <v-col cols="12" md="11" class="fielddesc pa-0">
        <pre translate="no" style="background:#fafafa">
        {
          "resultCode": 0,
        }          
        </pre>
      </v-col>
      
    </v-row>
    <v-row justify="center" dense>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">resultCode</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center"><a @click="nav('apiCommon')">{{this.$i18n.locale == 'ko' ? '여기를 눌러서 상세한 코드값을 확인하세요.' : 'Click here to see the detailed code values.'}}</a></v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="12" md="11">
      </v-col>
    </v-row>



  </v-container>
</template>
<script>

export default {

    mounted() {

    },

    data: () => ({

    }),

    methods: {

      nav(name){
        this.$router.push("/ApiDoc/"+name).catch(()=>{});
      },

    },

    created(){
      //apiProductList
    }


}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

table{
  width: 100%;
  border-collapse: collapse;
}
th, td {
  border: 1px solid #eaeaea;
  padding: 10px;
}
.fieldname {
  background: #f1f3f4;
  border: 1px solid #eaeaea;
}
.fielddesc {
  border: 1px solid #eaeaea;
  padding-left: 15px;
  padding-right: 15px;
}

</style>